import { MicrosoftXboxControllerBatteryChargingIcon } from './MicrosoftXboxControllerBatteryChargingIcon';

/**
 * author: Contributors
 * id 738FB781-E590-444B-85B8-1773DDC814E9
 * name microsoft-xbox-controller-battery-charging
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-xbox-controller-battery-charging.svg
 * tags
 * - Gaming / RPG 
 * - Battery 
 */
export const MicrosoftXboxGamepadBatteryChargingIcon = MicrosoftXboxControllerBatteryChargingIcon;
export default MicrosoftXboxGamepadBatteryChargingIcon